module.exports = __webpack_public_path__ + "img/pure.a032a286.png";